import React from 'react';
import { Check, X } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { PurchasePopup } from './PurchasePopup';
import { Testimonials } from './Testimonials';
import { Guarantee } from './Guarantee';
import { Faq } from './Faq';
export function SalesLetter() {
  const purchaseUrl = 'https://colorpack.online/cart/47899538817163:1?storefront=true';
  return <div className="min-h-screen bg-[#faf6f0] text-gray-800 font-sans selection:bg-[#fdf8f5] selection:text-[#5d4a6e]" data-id="element-47">
      <PurchasePopup data-id="element-48" />

      {/* HEADER */}
      <header className="py-6 flex justify-center bg-white/50 backdrop-blur-sm sticky top-0 z-40 border-b border-[#f0e6d2]" data-id="element-49">
        <img src="https://cdn.magicpatterns.com/uploads/g9EytFW7XjM1KcZ1q6LSf6/logo_reseteo.png" alt="Dra Karito Logo" className="h-16 md:h-20 object-contain" data-id="element-50" />
      </header>

      <main className="max-w-3xl mx-auto px-5 py-10 md:py-16" data-id="element-51">
        {/* HERO SECTION */}
        <section className="text-center mb-16" data-id="element-52">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-[#5d4a6e] mb-6 leading-tight tracking-tight" data-id="element-53">
            KIT DE RESETEO EMOCIONAL™
          </h1>

          {/* BIG PROMISE — above the fold */}
          <p className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-[#4a3b5c] mb-6 leading-tight" data-id="element-54">
            En 30 días tendrás tu propio sistema para gestionar tus emociones
            con más{' '}
            <span className="text-[#c08a92]" data-id="element-55">calma, claridad y confianza</span>,
            dedicando{' '}
            <span className="bg-[#fbe9b8] text-[#4a3b5c] px-2 rounded box-decoration-clone" data-id="element-56">
              solo 15 minutos al día.
            </span>
          </p>
          <p className="text-base md:text-xl text-gray-600 mb-8 italic" data-id="element-57">
            Incluso si llevas años sintiendo que tu pasado sigue controlando tu
            presente.
          </p>

          <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" className="block mb-10 hover:opacity-95 transition-opacity" data-id="element-58">
            <img src="https://cdn.magicpatterns.com/uploads/rGNjLkagBtCc3sbNp4GRjB/reseteo_principal.png" alt="Kit de Reseteo Emocional Principal" className="w-full max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-59" />
          </a>

          <CtaButton label="QUIERO MI KIT DE RESETEO EMOCIONAL™" subline="Acceso inmediato · Descarga digital · Solo $17 USD" data-id="element-60" />
        </section>

        {/* STORY / BODY COPY */}
        <section className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed mb-16" data-id="element-61">
          <p className="font-bold text-center text-2xl text-[#5d4a6e] mb-8" data-id="element-62">
            Hay algo que nadie te dijo…
          </p>

          <p className="text-center" data-id="element-63">No eres una persona débil.</p>
          <p className="text-center" data-id="element-64">No estás rota.</p>
          <p className="text-center mb-8" data-id="element-65">
            Y probablemente tampoco te falte fuerza de voluntad.
          </p>

          <p className="font-bold text-center text-[#c08a92]" data-id="element-66">
            Lo que ocurre es mucho más simple…
          </p>

          <p className="text-center text-2xl font-serif font-bold text-[#5d4a6e] my-8" data-id="element-67">
            <span className="bg-[#fdf8f5] px-2" data-id="element-68">
              Nunca te enseñaron cómo procesar lo que sientes.
            </span>
          </p>

          <p data-id="element-69">Así que hiciste lo único que sabías hacer.</p>
          <p data-id="element-70">Seguiste adelante.</p>
          <p data-id="element-71">Sonreíste.</p>
          <p data-id="element-72">Trabajaste.</p>
          <p data-id="element-73">Cuidaste de todos.</p>
          <p data-id="element-74">Intentaste distraerte.</p>

          <p className="mt-8 font-bold text-[#5d4a6e]" data-id="element-75">
            Pero cada cierto tiempo…
          </p>
          <p data-id="element-76">Ese vacío volvía.</p>
          <p data-id="element-77">Esa tristeza aparecía otra vez.</p>
          <p data-id="element-78">Ese recuerdo regresaba.</p>
          <p data-id="element-79">Y esos pensamientos empezaban de nuevo.</p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-[#f0e6d2] my-10 text-center space-y-4" data-id="element-80">
            <p className="italic text-[#c08a92] font-serif text-xl" data-id="element-81">
              ”¿Por qué sigo sintiéndome así?”
            </p>
            <p className="italic text-[#c08a92] font-serif text-xl" data-id="element-82">
              ”¿Por qué no puedo simplemente soltar?”
            </p>
            <p className="italic text-[#c08a92] font-serif text-xl" data-id="element-83">
              ”¿Será que nunca voy a superar esto?”
            </p>
          </div>

          <p className="font-bold text-2xl text-center text-[#5d4a6e] mb-6" data-id="element-84">
            La verdad es esta…
          </p>

          <p data-id="element-85">La mayoría de las personas intenta sanar pensando más.</p>
          <p data-id="element-86">Analizando más.</p>
          <p data-id="element-87">Recordando más.</p>
          <p data-id="element-88">Intentando entender todo.</p>

          <p className="mt-8 font-bold" data-id="element-89">
            Pero mientras todo siga dando vueltas únicamente dentro de tu
            cabeza…
          </p>
          <p className="text-xl font-bold text-[#c08a92]" data-id="element-90">
            Tu mente nunca descansa.
          </p>

          <p className="mt-8" data-id="element-91">Porque las emociones que nunca se procesan…</p>
          <p data-id="element-92">Simplemente cambian de lugar.</p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 my-8 text-center font-medium text-[#5d4a6e]" data-id="element-93">
            <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f0e6d2]" data-id="element-94">
              Se convierten en ansiedad.
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f0e6d2]" data-id="element-95">
              En culpa.
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f0e6d2]" data-id="element-96">
              En miedo.
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f0e6d2]" data-id="element-97">
              En insomnio.
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f0e6d2]" data-id="element-98">
              En agotamiento.
            </div>
          </div>

          <p className="text-center text-xl" data-id="element-99">
            En esa sensación de estar sobreviviendo…
          </p>
          <p className="text-center text-2xl font-bold text-[#5d4a6e]" data-id="element-100">
            En lugar de vivir.
          </p>
        </section>

        {/* CHECKLIST SECTION */}
        <section className="mb-16" data-id="element-101">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border-t-4 border-[#c08a92]" data-id="element-102">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#5d4a6e] mb-8 text-center" data-id="element-103">
              Quizás hoy te reconoces en alguna de estas situaciones…
            </h2>

            <ul className="space-y-4 mb-8" data-id="element-104">
              {['Piensas demasiado antes de dormir.', 'Revives conversaciones una y otra vez.', 'Te cuesta dejar atrás lo que viviste.', 'Sonríes por fuera, pero por dentro te sientes agotada.', 'Sientes culpa por cosas que ya pasaron.', 'Has intentado de todo, pero siempre terminas igual.', 'Quieres sentir paz… pero no sabes por dónde empezar.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg" data-id="element-105">
                  <Check className="text-[#c08a92] shrink-0 mt-1" size={24} data-id="element-106" />
                  <span data-id="element-107">{item}</span>
                </li>)}
            </ul>

            <div className="text-center space-y-4 text-lg" data-id="element-108">
              <p className="font-bold text-[#5d4a6e]" data-id="element-109">
                Si respondiste “sí” aunque sea a una…
              </p>
              <p className="text-xl font-serif italic text-[#c08a92]" data-id="element-110">
                No estás sola.
              </p>
              <p data-id="element-111">Y, sobre todo…</p>
              <p className="font-bold" data-id="element-112">
                No significa que estés condenada a vivir así.
              </p>
            </div>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-center mt-12" data-id="element-113">
            <p data-id="element-114">Porque el problema nunca fue tu capacidad para sanar…</p>
            <p className="text-2xl font-bold text-[#5d4a6e] bg-[#fdf8f5] inline-block px-4 py-2 rounded-lg" data-id="element-115">
              El problema fue no tener un camino claro.
            </p>

            <p className="mt-8" data-id="element-116">
              Imagina intentar llegar a un lugar que nunca has visitado…
            </p>
            <p className="font-medium text-[#c08a92]" data-id="element-117">Sin mapa.</p>
            <p className="font-medium text-[#c08a92]" data-id="element-118">Sin señales.</p>
            <p className="font-medium text-[#c08a92]" data-id="element-119">Sin dirección.</p>

            <p className="mt-8" data-id="element-120">
              Eso es exactamente lo que muchas personas hacen con sus emociones.
            </p>
            <p data-id="element-121">Quieren sentirse mejor.</p>
            <p className="font-bold text-[#5d4a6e]" data-id="element-122">
              Pero nadie les muestra qué hacer.
            </p>
            <p className="font-bold text-[#5d4a6e]" data-id="element-123">Ni cuándo.</p>
            <p className="font-bold text-[#5d4a6e]" data-id="element-124">Ni cómo.</p>
          </div>

          <div className="mt-12" data-id="element-125">
            <CtaButton label="SÍ, QUIERO UN CAMINO CLARO" data-id="element-126" />
          </div>
        </section>

        {/* METHOD REVEAL */}
        <section className="mb-16 text-center space-y-6 text-lg md:text-xl" data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#5d4a6e] mb-8" data-id="element-128">
            Aquí nació el Método RESET™
          </h2>

          <p data-id="element-129">
            Después de estudiar las herramientas más efectivas de reflexión,
            escritura guiada y organización emocional…
          </p>
          <p className="font-bold" data-id="element-130">
            Diseñamos un sistema extremadamente sencillo.
          </p>

          <p className="mt-8" data-id="element-131">
            Un método que no busca que ignores lo que sientes.
          </p>
          <p data-id="element-132">Ni que luches contra tus emociones.</p>
          <p className="text-2xl font-bold text-[#c08a92] my-6" data-id="element-133">
            Sino que aprendas a darles un lugar.
          </p>

          <p className="font-serif italic text-2xl text-[#5d4a6e]" data-id="element-134">
            Paso a paso.
          </p>
          <p className="font-serif italic text-2xl text-[#5d4a6e]" data-id="element-135">
            Día tras día.
          </p>
          <p className="font-serif italic text-2xl text-[#5d4a6e] bg-[#fdf8f5] inline-block px-4 py-1 rounded-lg" data-id="element-136">
            Solo 15 minutos.
          </p>
        </section>

        {/* PRODUCT REVEAL */}
        <section className="mb-16 text-center" data-id="element-137">
          <p className="text-xl font-bold text-[#c08a92] uppercase tracking-widest mb-4" data-id="element-138">
            Presentamos…
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#5d4a6e] mb-6" data-id="element-139">
            KIT DE RESETEO EMOCIONAL™
          </h2>
          <p className="text-2xl font-medium text-gray-800 mb-10" data-id="element-140">
            Tu sistema personal para recuperar el control de tus emociones.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-141">
            <div className="bg-white p-4 rounded-xl shadow-sm border border-red-100 text-gray-500 line-through" data-id="element-142">
              No es un ebook.
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-red-100 text-gray-500 line-through" data-id="element-143">
              No es un curso interminable.
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-red-100 text-gray-500 line-through" data-id="element-144">
              No son consejos vacíos.
            </div>
          </div>

          <p className="text-xl md:text-2xl font-bold text-[#5d4a6e] leading-relaxed bg-white p-8 rounded-2xl shadow-md border-l-4 border-[#c08a92]" data-id="element-145">
            Es una colección de herramientas diseñadas para acompañarte durante
            los próximos 30 días y ayudarte a construir una rutina práctica de
            bienestar emocional.
          </p>
        </section>

        {/* WHAT YOU GET */}
        <section className="mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#5d4a6e] mb-12" data-id="element-147">
            Esto es lo que recibirás hoy
          </h2>

          <div className="space-y-6" data-id="element-148">
            {[{
            title: 'Manual Maestro del Reseteo Emocional™',
            img: 'https://cdn.magicpatterns.com/uploads/rGNjLkagBtCc3sbNp4GRjB/reseteo_principal.png'
          }, {
            title: 'Workbook de Liberación Emocional™',
            img: 'https://cdn.magicpatterns.com/uploads/rTJdZTK4veZFTy6Z8G8a9p/producto_1_reseteo.png'
          }, {
            title: 'Diario de Reseteo de 30 Días™',
            img: 'https://cdn.magicpatterns.com/uploads/cZLnJ3aRvikYfgGQzZgvPX/producto_2_reseteo.png'
          }, {
            title: 'Kit de Cartas Terapéuticas™',
            img: 'https://cdn.magicpatterns.com/uploads/dhMWfUL41Bkui1WmSscHGX/producto_3_reseteo.png'
          }, {
            title: 'Mapa de Reconstrucción Personal™',
            img: 'https://cdn.magicpatterns.com/uploads/8qZsqqeof9t6LT6sin37zy/producto_4_reseteo.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-2xl shadow-md border-2 border-[#e7d9c9] overflow-hidden" data-id="element-149">
                <div className="bg-[#c08a92] text-white px-5 md:px-6 py-4 flex items-center justify-between gap-3" data-id="element-150">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-151">
                    <span className="w-8 h-8 rounded-full bg-white/25 flex items-center justify-center shrink-0" data-id="element-152">
                      <Check size={18} className="text-white" data-id="element-153" />
                    </span>
                    <h3 className="font-bold text-base md:text-xl leading-tight" data-id="element-154">
                      {item.title}
                    </h3>
                  </div>
                  <span className="shrink-0 bg-white text-[#c08a92] font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-155">
                    Incluido
                  </span>
                </div>
                {item.img && <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" className="block hover:opacity-95 transition-opacity" data-id="element-156">
                    <img src={item.img} alt={item.title} className="w-full" data-id="element-157" />
                  </a>}
              </div>)}
          </div>

          <div className="mt-12" data-id="element-158">
            <CtaButton label="QUIERO TODO ESTO" data-id="element-159" />
          </div>
        </section>

        {/* BONUSES */}
        <section className="mb-16" data-id="element-160">
          <div className="text-center space-y-4 mb-10" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#5d4a6e]" data-id="element-162">
              Pero eso no es todo…
            </h2>
            <p className="text-xl" data-id="element-163">
              Quiero que realmente tengas todas las herramientas para empezar.
            </p>
            <p className="text-xl font-bold" data-id="element-164">
              Por eso recibirás completamente{' '}
              <span className="text-[#c08a92] bg-[#fdf8f5] px-2 py-1 rounded" data-id="element-165">
                GRATIS:
              </span>
            </p>
          </div>

          <div className="space-y-6" data-id="element-166">
            {[{
            name: '100 Afirmaciones para Días Difíciles™',
            img: 'https://cdn.magicpatterns.com/uploads/cjfqk3THTNmZ24Km4pytNt/bono_1_reseteo.png'
          }, {
            name: 'Guía “Qué Hacer Cuando Recaigo”™',
            img: 'https://cdn.magicpatterns.com/uploads/1KRSpSSY32j7dUqMP6TV7B/bono_2_reseteo.png'
          }, {
            name: '50 Ejercicios de Respiración y Regulación™',
            img: 'https://cdn.magicpatterns.com/uploads/nfie98Rny8JLrniKEm1WHa/bono_3_reseteo.png'
          }, {
            name: 'Pack de Fondos para Celular con Recordatorios Emocionales™',
            img: 'https://cdn.magicpatterns.com/uploads/wV7Gov85Tpzw5Uw7hHAYPH/bono_4_reseteo.png'
          }, {
            name: 'Mini Planner de Autocuidado™',
            img: 'https://cdn.magicpatterns.com/uploads/krzuyKrxQ1rW4WtAtBbuG3/bono_5_reseteo.png'
          }, {
            name: 'Checklist “Señales de que Realmente Estás Avanzando”™',
            img: 'https://cdn.magicpatterns.com/uploads/852t8HurgK3E1iKRSpqqjH/bono_6_reseteo.png'
          }, {
            name: 'Guía para Crear Tu Espacio Seguro en Casa™',
            img: 'https://cdn.magicpatterns.com/uploads/bQD5L5CkLbMy2nWuSa6o6e/bono_7_reseteo.png'
          }].map((bono, i) => <div key={i} className="bg-white rounded-2xl shadow-md border-2 border-[#f0e6d2] overflow-hidden" data-id="element-167">
                <div className="bg-[#5d4a6e] text-white px-6 py-4 flex items-center justify-between gap-3" data-id="element-168">
                  <div className="flex items-center gap-3" data-id="element-169">
                    <span className="text-2xl shrink-0" data-id="element-170">🎁</span>
                    <div data-id="element-171">
                      <span className="text-[#f0d99a] font-bold block text-xs uppercase tracking-wider" data-id="element-172">
                        Bono #{i + 1}
                      </span>
                      <span className="font-semibold text-base md:text-lg leading-tight" data-id="element-173">
                        {bono.name}
                      </span>
                    </div>
                  </div>
                  <span className="shrink-0 bg-[#c9a24b] text-[#4a3b5c] font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-174">
                    GRATIS hoy
                  </span>
                </div>
                {bono.img && <a href={purchaseUrl} target="_blank" rel="noopener noreferrer" className="block hover:opacity-95 transition-opacity" data-id="element-175">
                    <img src={bono.img} alt={bono.name} className="w-full" data-id="element-176" />
                  </a>}
              </div>)}
          </div>
        </section>

        {/* FUTURE PACING */}
        <section className="mb-16 text-center space-y-6 text-lg md:text-xl" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#5d4a6e] mb-8" data-id="element-178">
            Imagina cómo podrías sentirte dentro de 30 días…
          </h2>

          <p data-id="element-179">No porque tu vida sea perfecta.</p>
          <p data-id="element-180">No porque nunca vuelvas a tener un día difícil.</p>
          <p className="font-bold text-[#c08a92]" data-id="element-181">
            Sino porque tendrás algo que hoy probablemente no tienes.
          </p>

          <p className="text-3xl font-serif font-bold text-[#5d4a6e] my-8 bg-[#fdf8f5] inline-block px-6 py-3 rounded-xl border border-[#f0e6d2]" data-id="element-182">
            Un sistema.
          </p>

          <p data-id="element-183">Sabrás exactamente qué hacer cuando aparezca la ansiedad.</p>
          <p data-id="element-184">Cuando llegue una recaída.</p>
          <p data-id="element-185">Cuando tu mente empiece a dar vueltas.</p>
          <p data-id="element-186">Cuando sientas que todo pesa demasiado.</p>

          <p className="mt-8 font-bold" data-id="element-187">
            Ya no dependerás de esperar “sentirte mejor”.
          </p>
          <p className="text-2xl font-bold text-[#5d4a6e]" data-id="element-188">
            Tendrás herramientas para actuar.
          </p>
        </section>

        <Testimonials data-id="element-189" />

        {/* OFFER SECTION */}
        <section id="oferta" className="mb-16 scroll-mt-24" data-id="element-190">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-center text-[#5d4a6e] mb-10" data-id="element-191">
            OFERTA
          </h2>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-dashed border-[#c08a92] relative" data-id="element-192">
            <div className="space-y-3 mb-8 text-lg text-gray-600 max-w-sm mx-auto" data-id="element-193">
              <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-194">
                <span data-id="element-195">Manual Maestro</span> <span data-id="element-196">$49</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-197">
                <span data-id="element-198">Workbook</span> <span data-id="element-199">$67</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-200">
                <span data-id="element-201">Diario 30 Días</span> <span data-id="element-202">$37</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-203">
                <span data-id="element-204">Cartas Terapéuticas</span> <span data-id="element-205">$47</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2" data-id="element-206">
                <span data-id="element-207">Mapa Personal</span> <span data-id="element-208">$57</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2 font-bold text-[#c08a92]" data-id="element-209">
                <span data-id="element-210">Bonos</span> <span data-id="element-211">$141</span>
              </div>
              <div className="flex justify-between pt-4 text-xl font-bold text-gray-400 line-through" data-id="element-212">
                <span data-id="element-213">Valor Total:</span> <span data-id="element-214">$398 USD</span>
              </div>
            </div>

            <div className="text-center space-y-4 mb-8" data-id="element-215">
              <p className="text-xl" data-id="element-216">
                Pero hoy no pagarás{' '}
                <span className="line-through text-gray-400" data-id="element-217">$398</span>.
              </p>
              <p className="text-xl" data-id="element-218">
                Ni <span className="line-through text-gray-400" data-id="element-219">$197</span>.
              </p>
              <p className="text-xl" data-id="element-220">
                Ni siquiera{' '}
                <span className="line-through text-gray-400" data-id="element-221">$97</span>.
              </p>

              <p className="text-gray-600 mt-6 italic max-w-lg mx-auto" data-id="element-222">
                "Porque nuestra misión es que más personas tengan acceso a
                herramientas prácticas para fortalecer su bienestar emocional."
              </p>

              <p className="text-xl font-bold text-[#5d4a6e] mt-6" data-id="element-223">
                Por eso hoy puedes obtener el Kit de Reseteo Emocional™ por
                solo…
              </p>
            </div>

            <div className="text-center mb-10" data-id="element-224">
              <div className="text-7xl md:text-8xl font-black text-[#c08a92] mb-4 drop-shadow-sm" data-id="element-225">
                $17{' '}
                <span className="text-3xl md:text-4xl text-[#5d4a6e]" data-id="element-226">USD</span>
              </div>
              <div className="flex flex-wrap justify-center gap-3 text-sm md:text-base font-bold text-[#5d4a6e] uppercase tracking-wider" data-id="element-227">
                <span className="bg-[#fdf8f5] px-3 py-1 rounded-full border border-[#f0e6d2]" data-id="element-228">
                  Un único pago
                </span>
                <span className="bg-[#fdf8f5] px-3 py-1 rounded-full border border-[#f0e6d2]" data-id="element-229">
                  Acceso inmediato
                </span>
                <span className="bg-[#fdf8f5] px-3 py-1 rounded-full border border-[#f0e6d2]" data-id="element-230">
                  Sin suscripciones
                </span>
              </div>
            </div>

            <CtaButton label="QUIERO MI KIT DE RESETEO EMOCIONAL™" subline="Acceso inmediato · Descarga digital · Solo $17 USD" className="text-2xl py-5" data-id="element-231" />
          </div>

          <CountdownTimer data-id="element-232" />
        </section>

        {/* AFTER PURCHASE */}
        <section className="mb-16 text-center space-y-4 bg-white p-8 rounded-2xl shadow-sm border border-[#f0e6d2]" data-id="element-233">
          <h3 className="text-2xl font-serif font-bold text-[#5d4a6e] mb-6" data-id="element-234">
            ¿Qué pasa después de comprar?
          </h3>
          <p className="text-lg" data-id="element-235">
            En pocos minutos recibirás acceso a todo el material digital.
          </p>
          <p className="text-lg" data-id="element-236">
            Podrás descargarlo, imprimirlo o utilizarlo desde tu computadora,
            tablet o celular.
          </p>
          <p className="text-xl font-bold text-[#c08a92] mt-4" data-id="element-237">
            Y ese mismo día podrás comenzar tu Día 1.
          </p>
        </section>

        {/* GUARANTEE */}
        <Guarantee data-id="element-238" />

        {/* WHO IS IT FOR */}
        <section className="mb-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-239">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-[#5d4a6e]" data-id="element-240">
            <h3 className="text-2xl font-serif font-bold text-[#5d4a6e] mb-6" data-id="element-241">
              Este kit es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-242">
              {['Quieres dejar de sentir que tus emociones controlan tu vida.', 'Buscas una rutina sencilla y práctica.', 'Prefieres avanzar a tu propio ritmo.', 'Necesitas herramientas claras, no teoría interminable.', 'Estás lista para empezar a elegirte también a ti.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-243">
                  <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-244" />
                  <span className="text-gray-700" data-id="element-245">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-gray-300 opacity-90" data-id="element-246">
            <h3 className="text-2xl font-serif font-bold text-gray-500 mb-6" data-id="element-247">
              Pero este kit NO es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-248">
              {['Buscas una solución mágica de un día para otro.', 'No estás dispuesto(a) a dedicar 15 minutos al día.', 'Esperas que alguien haga el trabajo por ti.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-249">
                  <X className="text-red-400 shrink-0 mt-1" size={20} data-id="element-250" />
                  <span className="text-gray-500" data-id="element-251">{item}</span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* FAQ */}
        <Faq data-id="element-252" />

        {/* CLOSE */}
        <section className="text-center space-y-6 text-lg md:text-xl mb-16" data-id="element-253">
          <h2 className="text-3xl font-serif font-bold text-[#5d4a6e] mb-8" data-id="element-254">
            Hoy tienes dos opciones…
          </h2>

          <p data-id="element-255">Seguir esperando que algún día las cosas cambien por sí solas.</p>
          <p className="font-bold" data-id="element-256">
            O empezar hoy a construir un sistema que puedas utilizar durante
            toda tu vida.
          </p>

          <p className="mt-8 text-gray-500 italic" data-id="element-257">
            La decisión es completamente tuya.
          </p>

          <p className="mt-8" data-id="element-258">Pero si has llegado hasta aquí…</p>
          <p data-id="element-259">
            Quizá sea porque una parte de ti ya está lista para dar ese primer
            paso.
          </p>

          <p className="mt-8" data-id="element-260">
            En 30 días podrías seguir exactamente donde estás hoy…
          </p>
          <p data-id="element-261">O podrías mirar atrás y decir:</p>

          <div className="my-10" data-id="element-262">
            <p className="text-2xl md:text-3xl font-serif font-bold text-[#5d4a6e] bg-[#fdf8f5] inline-block px-8 py-6 rounded-2xl border border-[#f0e6d2] shadow-sm" data-id="element-263">
              “Fue el día en que decidí empezar a elegirme.”
            </p>
          </div>

          <p className="mb-8 font-medium" data-id="element-264">
            Haz clic en el botón de abajo y comienza hoy mismo con el <br data-id="element-265" />
            <span className="font-bold text-[#c08a92]" data-id="element-266">
              Kit de Reseteo Emocional™
            </span>
            .
          </p>

          <CtaButton label="QUIERO MI KIT DE RESETEO EMOCIONAL™" subline="Acceso inmediato · Descarga digital · Solo $17 USD" className="text-2xl py-5" data-id="element-267" />
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-white border-t border-[#f0e6d2] py-12 text-center px-5" data-id="element-268">
        <img src="https://cdn.magicpatterns.com/uploads/g9EytFW7XjM1KcZ1q6LSf6/logo_reseteo.png" alt="Dra Karito Logo" className="h-16 mx-auto mb-4 opacity-80 grayscale hover:grayscale-0 transition-all" data-id="element-269" />
        <p className="text-[#5d4a6e] font-serif font-bold tracking-widest text-sm mb-6" data-id="element-270">
          MENTE · CORAZÓN · TRANSFORMACIÓN
        </p>
        <p className="text-xs text-gray-400 max-w-2xl mx-auto mb-4" data-id="element-271">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-xs text-gray-400" data-id="element-272">
          © {new Date().getFullYear()} Dra Karito. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}